<template>
    <b-overlay :show="false">
        <BreadCrumb :sub-link="subLink" :title="title" :sub-title="subTitle" />
        <div class="pb-5">
            <div class="row">
                <div class="col-12">
                    <DirectChargeTabs :active="isEdit? 4:2" />
                </div>

                <div class="col-12 col-md-8 col-lg-6 m-auto">
                    <div class="card p-1 p-md-2">
                        <h2 class="mb-1">{{$t('triggerDirectCharge')}}</h2>
                        <b-skeleton-wrapper :loading="pageBusy">
                            <template #loading>
                                <b-card>
                                    <b-skeleton width="75%"></b-skeleton>
                                    <b-skeleton width="75%"></b-skeleton>
                                    <b-skeleton width="100%"></b-skeleton>
                                    <b-skeleton width="75%"></b-skeleton>
                                    <b-skeleton width="20%"></b-skeleton> <br />

                                    <b-skeleton width="75%"></b-skeleton>
                                    <b-skeleton width="100%"></b-skeleton>
                                    <b-skeleton width="75%"></b-skeleton>
                                    <b-skeleton width="75%"></b-skeleton> <br />

                                    <b-skeleton width="75%"></b-skeleton>
                                    <b-skeleton width="50%"></b-skeleton>
                                    <b-skeleton width="100%"></b-skeleton>
                                    <b-skeleton width="75%"></b-skeleton>
                                    <b-skeleton width="75%"></b-skeleton> <br />

                                    <b-skeleton width="100%"></b-skeleton>
                                    <b-skeleton width="75%"></b-skeleton>
                                    <b-skeleton width="25%"></b-skeleton>
                                    <b-skeleton width="50%"></b-skeleton>
                                    <b-skeleton width="75%"></b-skeleton> <br />
                                </b-card>
                            </template>
                            <div>
                                <div v-if="mode == 2" class="pt-4 pb-4 alert alert alert-danger text-center">
                                    <h4>{{t('failedToLoadDirectCharge')}}</h4>
                                    <b-button @click="getDirectCharge()">
                                        <feather-icon icon="LoaderIcon" /> {{t('reload')}}
                                    </b-button>
                                </div>
                                <div class="mt-1" v-else>
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="d-flex">
                                                <div v-for="(item, i) in operators" :key="i" class="w-100 text-center">
                                                    <img @click="setOperator(item)" :src="item.avatar" :class="`rounded cursor-pointer available-operators ${selectedOperator == item.value? 'active-operator': ''}`" width="75">
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-12 mt-2">
                                            <div>
                                                <label>{{t('mobileNumber')}}</label> <span class="text-danger">*</span>
                                                <div class="d-flex border bg-primary align-items-center rounded">
                                                    <div style="width: 50px; padding:1px">
                                                        <img :src="operators[selectedOperator].avatar" class="d-block rounded" style="width: 100%">
                                                    </div>
                                                    <div class="w-100">
                                                        <b-form-input type="number" id="mobile-wallet-number" :placeholder="operators[selectedOperator].number" v-model="directCharge.mobileWalletNumber" aria-required=""></b-form-input>
                                                    </div>
                                                </div>
                                                <!-- <b-input-group :append="directCharge.currencyCode">
                                                    <template #append>
                                                    </template>
                                                </b-input-group> -->
                                            </div>
                                        </div>
                                        <div class="col-12 mt-2">
                                            <div v-show="!specifiedAmount">
                                                <label>{{t('amount')}}</label> <span class="text-danger">*</span>
                                                <div class="d-flex">
                                                    <div class="w-100">
                                                        <b-form-input type="number" v-model="directCharge.amount" aria-required=""></b-form-input>
                                                    </div>
                                                    <div style="min-width: 100px;">
                                                        <select-currency :show-label="false" :currency-code="directCharge.currencyCode"  @currency-changed="currencyChanged" />
                                                    </div>
                                                </div>
                                                <!-- <b-input-group :append="directCharge.currencyCode">
                                                    <template #append>
                                                    </template>
                                                </b-input-group> -->
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <div>
                                                <label class="mt-2">{{t('description')}}</label>
                                                <b-textarea v-model="directCharge.description" maxlength="255">
                                                </b-textarea>
                                                <div>
                                                <small>
                                                        {{ directCharge.description.length }} / 255 {{ t('characters') }}
                                                </small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mt-1 d-flex justify-content-between align-items-center">
                                        <b-form-checkbox
                                            id="extraConfigurations"
                                            :checked="true"
                                            switch
                                            v-model="extraConfigurations"
                                        >
                                            {{t('showExtraConfigurations')}}
                                        </b-form-checkbox>
                                    </div>
                                    <div v-if="extraConfigurations">
                                        <div class="row">
                                            <!-- <div class="col-12 col-md-6">
                                                <div>
                                                    <label class="mt-2">{{t('discountAmount')}}</label>
                                                    <b-input type="number" v-model="directCharge.serviceDiscountAmount">
                                                    </b-input>
                                                </div>
                                            </div> -->
                                            <div class="col-12 col-md-6">
                                                <div>
                                                    <label class="mt-2">{{t('reference')}}</label>
                                                    <b-input type="text" v-model="directCharge.mchTransactionRef" maxlength="50">
                                                    </b-input>
                                                </div>
                                            </div>
                                            <div class="col-12 col-md-6">
                                                <div class="mt-2">
                                                    <receive @payment-method="getPaymentMethod($event)" :show-default="true" v-if="renderAccounts" :account="account"> </receive>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <FeeCalculation />

                                    <div class="mt-3 text-center">
                                        <b-button variant="primary" @click="triggerDirectCharge()">
                                        <feather-icon icon="SendIcon"></feather-icon> {{$t('triggerPayment')}}
                                        </b-button>
                                    </div>
                                </div>
                            </div>
                        </b-skeleton-wrapper>
                    </div>
                </div>
            </div>
            <b-modal id="direct-charge-modal" centered no-close-on-backdrop no-close-on-esc hide-footer hide-header size="md">
                <div class="p-2">
                    <h3 class="text-center">{{$t('waitingForAuthorization')}}</h3>
                    <div class="mt-2" style="height: 250px">
                        <div class="d-flex text-align-center justify-content-between">
                            <div class="">
                                <img :src="`${url}/logo.png`" alt="" class="rounded" style="height: 50px">
                            </div>
                            <div class="">
                                <img :src="`${url}/${timeoutId > 0? 'loader.gif': 'connection-lost.png'}`" alt="" class="rounded" style="height: 50px">
                            </div>
                            <div class="">
                                <img :src="operators[selectedOperator].avatar" alt="" class="rounded" style="height: 50px">
                            </div>
                        </div>
                        <div class="m-1 text-center">
                            <span class="font-weight-bolder text-dark" style="font-size: 30px;">
                                {{ currency(paymentRequest.amount, paymentRequest.currencyCode) }}
                            </span> 
                            <span class="text-primary">
                                {{ paymentRequest.currencyCode }}
                            </span>
                        </div>
                        <div class="mt-2 text-center">
                            {{ $t('waitingForUserToDial') }}<span style="font-size: 30px" class="d-block font-weight-bolder text-primary">{{ operators[selectedOperator].code }}</span>
                        </div>
                        <div class="mt-2 text-center" v-if="timeoutId <= 147">
                            <b-button size="sm" class="rounded-pill mt-1" variant="primary" @click="refreshStatus">{{ $t('refreshStatus') }}</b-button>
                        </div>

                    </div>
                    <div class="text-center">
                        <div :class="`d-md-flex`">
                            <div class="w-100 text-center">
                                <b-button size="sm" class="rounded-pill mt-1" variant="outline-danger" @click="confirmCloseRequest">{{ $t('cancelPayment') }}</b-button>
                            </div>
                            <div class="w-100 text-center" v-if="showCloseModal">
                                <b-button size="sm" class="rounded-pill mt-1" variant="dark" @click="closeModal">{{ $t('close') }}</b-button>
                            </div>
                        </div>
                    </div>
                </div>
            </b-modal>
        </div>
    </b-overlay>
</template>
<script>

import FeeCalculation from '@/views/components/fee-calculation/FeeCalculation.vue';
import vSelect from 'vue-select'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import globalData from '@/utils/globalData';
import utils from '@/utils';
import BreadCrumb from '../shared/BreadCrumb.vue';
import DirectChargeTabs from '../shared/DirectChargeTabs.vue';
import { directCharge as Api } from './api';
import Receive from '../receive-payments/Main.vue';
import commonApi from '@/services/api';
import SelectCurrency from '@/views/components/select-currency/select-currency.vue';

export default {
    name: 'Main',
    components:{
        SelectCurrency,
        FeeCalculation,
        BreadCrumb,
        DirectChargeTabs,
        vSelect,
        Receive
    },
    data() {
        const url = location.origin
        return{
            url,
            operators: [
                {label: 'MTN MoMo', value: 0, avatar: url + '/mtn.jpg', number: '671727374', validator: 'isMtn', code: '*126#'},
                {label: 'Orange Money', value: 1, avatar: url + '/orange.jpg', number: '691929394', validator: 'isOrange', code: '#150*50#'},
            ],
            selectedOperator: 0,
            intervalId: null,
            timeoutId: 150,
            renderAccounts: true,
            account: null,
            isEdit: false,
            mode: 1,
            org: {},
            feePayers: [
                {label: 'defaultSettings', value: null},
                {label: 'merchant', value: 1},
                {label: 'payer', value: 2},
                {label: 'evenSplit', value: 3},
            ],
            feePayer: '',
            feePayerInt: '',
            pageBusy: false,
            title: 'create',
            subTitle: 'directCharge',
            subLink: '/direct-charge',
            amount: '',
            directCharge: {
                feePayer: null,
                feePayerForCrossBorderTransactions: null,
                serviceDiscountAmount: '',
                amount: '',
                currencyCode: 'XAF',
                description: '',
                mchTransactionRef: '',
                acceptUserSpecifiedAmount: 0,
                receivingAccountId: '',
                enableAfterCreation: 0,
                fields:[]
            },
            specifiedAmount: false,
            showCloseModal: false,
            activate: true,
            submit: false,
            addPayeeQuestions: false,
            extraConfigurations: false,
            showPayeeForm: false,
            paymentRequest: {},
            currency: utils.formatCurrency
        }
    },
    watch: {
        timeoutId(val){
            if(val <= 100){
                this.stopPulling();
            }
            if(val <= 0){
                this.stopPulling();
            }
        },
        '$route' (to, from){
        // Code
            if(to.name == 'payment-links-create'){
                this.resetDirectCharge();
            }else{
                this.getDirectCharge();
                this.isEdit = true;
                this.title = 'edit';
            }
            console.log(to, from);
        },
        showPayeeForm(data){
            if(data && (!this.directCharge.fields || !this.directCharge.fields.length)){
                this.addItem('Tel');
                this.addItem(this.$t('email'));
            }
        }
    },
    mounted() {
        const org = localStorage.getItem('tz-cortex-org-user');
        if(org){
            try{
                this.org = JSON.parse(org);
            }catch(e){
                //
            }
        }
        if(this.$route.params.id){
            this.isEdit = true;
            this.title = 'edit'
            this.paymentLinkId = this.$route.params.id;
            if(this.$route.params.paymentLink){
                this.processPaymentLink(this.$route.params.paymentLink);
            }else{
                this.getDirectCharge(this.$route.params.id);
            }
        }
        this.org.logo = this.org.logo || 'https://fms.tranzak.me/cdn/pf/a3uuhng7te2nwy8v_undefined105277.80555612632pl.png'
        this.feePayer = this.feePayers[0];
        this.feePayerInt = this.feePayers[0];
        (async ()=>{
            this.userData = await globalData.getMerchantInfo();
            this.directCharge.currencyCode = this.userData?.primaryCurrencyCode || 'XAF';
        })();
    },
    methods: {
        closeModal(){
            this.stopPulling();
            this.$bvModal.hide('direct-charge-modal');
        },
        confirmCloseRequest(){
            this.$bvModal.msgBoxConfirm(this.$t('confirmCancelDirectCharge'), {
                title: this.$t('alert'),
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: this.$t('yes'),
                cancelTitle: this.$t('no'),
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            }).then(value => {
                if(value){
                    this.cancelDirectCharge();
                }
            }).catch(err => {
                // An error occurred
                console.log(err)
            })
        },
        setOperator(item) {
            this.selectedOperator = item.value; 
            this.directCharge.mobileWalletNumber = '';
            document.getElementById('mobile-wallet-number').focus();
        },
        resetDirectCharge(){
            this.directCharge = {
                feePayer: null,
                feePayerForCrossBorderTransactions: null,
                serviceDiscountAmount: '',
                amount: '',
                currencyCode: 'XAF',
                description: '',
                mchTransactionRef: '',
                receivingAccountId: '',
                enableAfterCreation: 0,
                fields:[]
            };
            this.activate = true;
            this.submit = false;
            this.isEdit = false;
            this.title = 'create';
            this.account = null;
            this.renderAccounts = false;
            this.$nextTick(() => {
                this.renderAccounts = true;
            });
            this.addItem('Tel', true);
            this.addItem(this.$t('email'));
        },
        processPaymentLink(data){
            const {feePayer,mchTransactionRef, amount, receivingAccountId, receivingAccount, description, acceptMultiplePayments, currencyCode, _id, status, expiresAt, serviceDiscountAmount, feePayerForCrossBorderTransactions, fields = [] } = data;
            this.directCharge = {feePayer, amount,mchTransactionRef, receivingAccountId, receivingAccount, description, acceptMultiplePayments, currencyCode, _id, status, expiresAt, serviceDiscountAmount, feePayerForCrossBorderTransactions, fields }
            console.log(fields)
            if(fields.length){
                console.log("hellollll")
                this.showPayeeForm = true;
                this.extraConfigurations = true;
            }
            this.account = receivingAccountId || null;
            this.receivingAccountId = this.account;
            this.directCharge.receivingAccountId = this.account;
            this.multiplePayments = this.directCharge.acceptMultiplePayments;
            this.feePayer = this.feePayers[feePayer || 0];
            this.feePayerInt = this.feePayers[feePayerForCrossBorderTransactions || 0];
        },
        async getDirectCharge(){
            this.pageBusy = true;
            await Api.view(this.$route.params.id || '').then(res=>{
                if(res.success && res.data) {
                    this.processPaymentLink(res.data);
                    this.mode = 1;
                }
                else{
                    this.mode = 2
                }
            }).catch(err=>{
                this.mode = 2;
                console.log(err);
            })
            this.pageBusy = false;
        },
        addItem(title = '', required = false){
            this.directCharge.fields.push({
                title, required,
            });
        },
        removeItem(index){
            this.directCharge.fields = this.directCharge.fields.filter((e,i) => i != index);
        },
        currencyChanged(data){
            console.log(data)
            this.directCharge.currencyCode = data;
        },
        stopPulling(){
            clearInterval(this.intervalId);
        },
        startPulling(){
            this.stopPulling();
            this.timeoutId = 150;
            this.intervalId = setInterval(this.verifyRequestStatus,4000);
        },
        triggerDirectCharge(){
            if(!this.directCharge.mobileWalletNumber || !utils.isValidCmNumber(this.directCharge.mobileWalletNumber)){
                this.showToast(this.$t('enterAValidPhoneNumber'));
                return false;
            }
            if(!utils[this.operators[this.selectedOperator].validator](this.directCharge.mobileWalletNumber)){
                this.showToast(`${this.$t('enterAValidPhoneNumberForSelectedOperator')} (${this.operators[this.selectedOperator].label})`);
                return false;
            }

            if((this.directCharge.amount <=0)){
                this.showToast(this.$t('pleaseFillAllRequiredFields'));
                return 0
            }
            
            if(this.directCharge.serviceDiscountAmount && this.directCharge.serviceDiscountAmount >= this.directCharge.amount){
                this.showToast(this.$t('discountAmountMustBeLessThanAmount'));
                return 0
            }
            // this.pageBusy = true;
            const params = {
                ...this.directCharge,
                mobileWalletNumber: `+237${this.directCharge.mobileWalletNumber}`
            };
            
            Api.createDirectCharge(params).then(res=>{
                // this.pageBusy = false;
                if(res.success && res.data){
                    this.$bvModal.show('direct-charge-modal');
                    this.paymentRequest = res.data;
                    this.startPulling();
                }
            }).catch(err => {
                this.pageBusy =false;
                this.showToast(this.$t('failedToTriggerDirectCharge'));
            })
            console.log(this.directCharge);
        },
        processRequest(payment = {}){
            if(payment.status != 2 && payment.transactionId){
                this.stopPulling();
                this.closeModal();
                this.$router.push(`/transactions/details/${payment.transactionId}`);
            }else if(payment.status < 0){
                this.stopPulling();
                this.closeModal();
                if(payment.status == -4){
                    this.showToast(this.$t('paymentCancelled'));
                }else{
                    this.showToast(this.$t('paymentFailedPleaseTryAgain'));
                }
            }
        },
        refreshStatus(){
            Api.refreshStatus(this.paymentRequest.id).then(res=>{
                if(res.success && res.data){
                    this.processRequest(res.data);
                }
            }).catch(err => {
                this.showToast(this.$t('tryAgain'));
            })
            console.log(this.directCharge);
        },
        verifyRequestStatus(){
            let hideLoadingSpinner = this.timeoutId == 150? true : false;
            this.timeoutId -=1;
            Api.view(this.paymentRequest.id, hideLoadingSpinner).then(res=>{
                if(res.success && res.data){
                    this.processRequest(res.data);
                }
            }).catch(err => {
                // this.showToast(this.$t('failedToTriggerDirectCharge'));
            })
            console.log(this.directCharge);
        },
        cancelDirectCharge(){
            Api.cancel(this.paymentRequest.id).then(res=>{
                this.showCloseModal = true;
                if(res.success && res.data){
                    this.closeModal();
                }
            }).catch(err => {
                this.showToast(this.$t('failedToCancelPaymentPleaseTryAgain'));
            })
            console.log(this.directCharge);
        },
        getPaymentMethod(data){
          this.directCharge.receivingAccountId = data.receivingAccountId || null;
        },
        filterInvoice() {
            console.log('ready to filter');
            // this.$emit('update-feedbacks', {
            //    "dateRange": this.dateRange,
            //    "status": (this.status != null && this.status.value != undefined)? this.status.value : '',
            //    "customer": this.customer
            // });
        },
        sendMoney(){
            if(parseFloat(this.amount) && this.funding) {
                return true;
            }
            else{
                return false;
            }
        },
        showToast(message,  variant = 'danger', title = null) {
            this.$bvToast.toast(`${message}`, {
            title: title || this.$t('error'),
            autoHideDelay: 5000,
            appendToast: true,
            solid: true,
            variant: variant
            })
        },
    },
    setup(props) {
    const { t } = useI18nUtils()

    return {
      // i18n
      t,
     }
  }
}
</script>
<style lang="scss" scope="">
    @import '@core/scss/vue/libs/vue-select.scss';
    @import '@core/scss/vue/libs/vue-flatpicker.scss';
    .available-operators {
        padding: 5px;
        border: 2px solid #fff;
    }
    .active-operator {
        border: 2px solid #990999;
    }
    .height-fill{
        height: 80%;
        min-height: 80%;
    }
    .color-light{
        color: #fff !important;
    }
    .txn-logos{
        margin-bottom: 3px;
        width: 40px;
        border-radius: 2px;
    }
</style>